import { toast } from "sonner";
import api from "./api";

/**
 * A file from an authenticated route, saved under `filename`; the server's
 * message on failure. Shared by the admin's Portal tab and the trainer's
 * portal pages (the cookie rides with `api`, so a plain link would not do).
 */
export async function downloadBlob(path, filename, setBusy, okMessage) {
  setBusy?.(true);
  try {
    const r = await api.get(path, { responseType: "blob" });
    const url = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 10_000);
    if (okMessage) toast.success(okMessage);
  } catch (err) {
    let msg = "Descărcarea nu a reușit.";
    try { msg = JSON.parse(await err?.response?.data?.text())?.detail || msg; } catch { /* keep the default */ }
    toast.error(msg);
  } finally {
    setBusy?.(false);
  }
}
